import { QuestionBase } from './question-base';

export class DatepickerQuestion extends QuestionBase<any> {
  controlType = 'datepicker';
}